<h2 i18n="organization upcoming events header@@organization-upcoming-events-header" class="widget-header h4 d-none d-lg-block">Upcoming events</h2>
<h3 class="text-muted h6">
  <a i18n="go to calendar text@@go-to-calendar" href="{{calendarUrl}}" target="_blank">Go to the calendar</a>
</h3>

<div *ngIf="allEvents; else loading" class="mt-2 compact-events-wrapper">
  <ul class="row list-unstyled" *ngIf="allEvents?.length > 0; else noEvents">
    <li *ngFor="let event of eventsToDisplay" class="li-width">
      <div class="site-container">
        <div class="site-initials">
          <div class="border-bottom event-day">{{event.EventDate| date:'d'}}</div>
          <div class="event-month small">{{event.EventDate| date:'LLL'}}</div>
        </div>
        <h4 class="site-title h6 mb-0 bolder"><a href="{{event.ItemUrl}}" class="events-clickable-link">{{event.Title}}</a></h4>
        <span class="site-title small d-block" *ngIf="event.Location">
            <i i18n-aria-label="@@event-location" aria-label="Event location" title="{{event.Location}}" role="img" alt="Event location" class="fa fa-map-marker mr-1"></i>{{(event.Location.length>30)? (event.Location | slice:0:30)+'...':(event.Location)}}
        </span>
        <span class="small site-title d-block">
            <span *ngIf="event.EventInstance === 'on diff day' && !event.AllDayEvent">{{event.EventDate| date:'d LLL'}} {{event.EventDate| date:'H:mm'}} - {{event.EndDate| date:'d LLL'}} {{event.EndDate| date:'H:mm'}}</span>
            <span *ngIf="event.EventInstance === 'on same day' && !event.AllDayEvent">{{event.EventDate| date:'d LLL'}} {{event.EventDate| date:'H:mm'}} - {{event.EndDate | date:'H:mm'}}</span>
            <span *ngIf="event.EventInstance === 'on diff day' && event.AllDayEvent">{{event.EventDate| date:'d LLL'}} - {{event.EndDate| date:'d LLL'}}<span class="pl-1" i18n="event allday@@event-allday">(All day)</span></span>
            <span *ngIf="event.EventInstance === 'on same day' && event.AllDayEvent">{{event.EventDate| date:'d LLL'}}<span class="pl-1" i18n="event allday1@@event-allday1">(All day)</span></span>
        </span>
      </div>
    </li>
  </ul>
</div>

<div *ngIf="allEvents && allEvents.length > 4" class="row justify-content-start">
  <div class="col-auto pr-0 pl-0">
    <button mat-button class="events-show-more-btn" (click)="clickShowPrevious()" [disabled]="numberOfShowMoreClicks === 0">
      <span class="small bolder" i18n="@@show-previous">Previous</span>
    </button>
  </div>
  <div class="pt-2">
    <span class="dot mr-1" [ngClass]="numberOfShowMoreClicks === 0 ? 'accent-2-bg-color' : 'dot-bg-color'"></span>
    <span *ngIf="allEvents.length > 4" class="dot mr-1" [ngClass]="numberOfShowMoreClicks === 1 ? 'accent-2-bg-color' : 'dot-bg-color'"></span>
    <span *ngIf="allEvents.length > 8" class="dot" [ngClass]="numberOfShowMoreClicks === 2 ? 'accent-2-bg-color' : 'dot-bg-color'"></span>
  </div>
   <div class="col-auto pr-0 pl-0">
    <button mat-button class="events-show-more-btn" (click)="clickShowNext()" [disabled]="numberOfShowMoreClicks === 2 || numberOfShowMoreClicks === maxNumberOfShowMoreClicks">
      <span class="small bolder" i18n="@@show-next">Next</span>
    </button>
  </div>
 </div>
 
<ng-template #linkToCalendar>
  <div class="col-auto mt-4 text-center">
      <span i18n="events find more@@events-find-more">Find more events in the <app-action-link [href]="calendarUrl" [target]="'blank'">Calendar</app-action-link></span>
  </div>
</ng-template>

<ng-template #loading>
  <div *ngIf="errorSubject$ | async as err; else innerLoading">
    <app-error-templates [error]="err.status" [componentName]="componentName"></app-error-templates>
  </div>
  <ng-template #innerLoading>
    <div>
      <app-widget-placeholder></app-widget-placeholder>
    </div>
  </ng-template>
</ng-template>

<ng-template #noEvents>
  <div *ngIf="errorSubject$ | async as err; else noRealEvents">
      <app-error-templates [error]="err.status" [componentName]="componentName"></app-error-templates>
  </div>
  <ng-template #noRealEvents>
      <div>
          <app-text-placeholder>
              <p class="text-muted" i18n="no events@@no-events">No future events.</p>
          </app-text-placeholder>
      </div>
  </ng-template>
</ng-template>
